import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';

export const BreadcrumbsContext = createContext();

const BreadcrumbsProvider = ({ children }) => {
  const [values, setValues] = useState({
    label: '',
    icon: '',
  });

  return (
    <BreadcrumbsContext.Provider
      value={{ setBreadcrumb: obj => setValues(obj), values }}
    >
      {children}
    </BreadcrumbsContext.Provider>
  );
};

BreadcrumbsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
};

export default BreadcrumbsProvider;
